import styled, { css } from 'styled-components/macro'

export const Wrapper = styled.header`
  ${({ theme }) => css`
    background-color: ${theme.colors.primary};
  `}
  width: 100%;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
`
